const MaxCharacterObject = {
  dashboard: {
    eventname: 60,
    eventdescription: 1000,
    country: 50,
    seocode: 30,
    branding: {
      appmenu: {
        displaytabname: 12,
      },
    },
    content: {
      schedule: {
        trackname: 30,
        title: 100,
        location: 50,
        description: 4000,
        pushmessage: 235,
        displaytabname: 18,
      },
      sponsor: {
        name: 100,
        description: 4000,
        weblink: 500,
        facebook: 100,
        twitter: 100,
        linkedin: 100,
        whatsapp: 100,
        contactperson: 100,
        sponsoremail: 100,
        displaytabname: 18,
        membershiptitle: 20,
      },
      speaker: {
        firstname: 255,
        lastname: 255,
        company: 60,
        position: 60,
        description: 4000,
        displaytabname: 18,
      },
      exhibitor: {
        name: 100,
        booth: 20,
        about: 4000,
        displaytabname: 18,
      },
      maps: {
        name: 50, // Location map
        mapname: 50, // Interactive map
        displaytabname: 18,
      },
      news: {
        newstitle: 80,
        newscontent: 2000,
        displaytabname: 18,
      },
      social: {
        displaytabname: 18,
      },
      message: {
        displaytabname: 18,
      },
      about: {
        category: 50,
        title: 35,
        content: 5000,
        displaytabname: 18,
      },
      webview: {
        displaytabname: 18,
      },
      gallery: {
        displaytabname: 18,
      },
      survey: {
        displaytabname: 18,
      },
      community: {
        categoryname: 35,
        description: 50,
        displaytabname: 18,
      },
      attendee: {
        displaytabname: 18,
      },
      gamification: {
        displaytabname: 18,
      },
      advertisement: {
        displaytabname: 18,
        advtname: 255,
        externallink: 255,
      },
    },
    gamification: {
      reward: {
        gamification_title: 100,
        gamification_desc: 1000,
      },
      challenge: {
        challengename: 35,
        challengedesc: 50,
      },
    },
    tickets: {
      wizard: {
        companyname: 50,
        companyaddress: 100,
        taxname: 25,
        congratulations: 500,
      },
      settings: {
        companyname: 50,
        companyaddress: 100,
        taxname: 25,
        congratulations: 500,
      },
      appusers: {
        firstname: 255,
        lastname: 255,
        groupname: 30,
      },
      managetickets: {
        ticketname: 100,
        tickettag: 15,
        ticketdesc: 50,
        taxname: 25,
      },
      coupons: {
        couponcode: 20,
      },
      proposalwizard: {
        category: 20,
      },
      proposaldashboard: {
        category: 20,
      },
    },
    polls: {
      liveqa: {
        question: 300,
      },
      poll: {
        question: 300,
        option1: 50,
        option2: 50,
        option3: 50,
        option4: 50,
      },
    },
    support: {
      message: 1000,
    },
    outreach: {
      title: 100,
      content: 235,
    },
    accountsettings: {
      appstore: {
        displayname_appstore: 30,
        displayname_downloadedapp: 12,
        short_description: 80,
        description: 4000,
      },
    },
  },
};

export default MaxCharacterObject;
